// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOMEPAGE_SEARCH_IN_BAZAAR = "Hledej v bazaru";
export const HOMEPAGE_SEARCH_IN_BAZAAR_PLACEHOLDER = "Hledej inzer\u00e1ty v bazaru";
